export function identity<T, U = T>(it: T): U {
    return it as unknown as U;
}
